import { Box, Button, constants, Image, Text } from '@redbubble/design-system';
import { useIntl } from '@redbubble/next/intl';
import { useRouter } from 'next/router';
import { getImageUrl } from '../../../../utils/common';
import { messages } from './messages';
import styles from './SubscribeBannerFooter.module.scss';

export const SubscribeBannerFooter: React.FC = () => {
  const intl = useIntl();
  const router = useRouter();

  const handleClick = () => {
    router.push('/signup');
  };
  return (
    <div className={styles.container}>
      <div id="footer-signup" className={styles.content}>
        <Box className={styles.footerContainer} data-testid="subscribe-banner">
          <Image
            alt=""
            src={getImageUrl('/banner/smiley.png')}
            className={styles.smiley}
          />
          <Box>
            <Text className={styles.text}>
              {intl.formatMessage(messages.member)}
            </Text>
            <Text className={styles.text}>
              {intl.formatMessage(messages.discount)}
            </Text>
          </Box>
          <Box className={styles.buttonWrapper}>
            <Button
              intent={constants.PRIMARY}
              aria-label={intl.formatMessage(messages.signUp)}
              onClick={handleClick}
              strong
            >
              <Text type="display5" className={styles.buttonLabel}>
                {intl.formatMessage(messages.signUp)}
              </Text>
            </Button>
          </Box>
          <Image
            alt=""
            src={getImageUrl('/banner/stars.png')}
            className={styles.stars}
          />
        </Box>
      </div>
    </div>
  );
};
